import { Routes } from "@angular/router";
import { NotFoundComponent } from "./shared/global/not-found/not-found.component";
import { AccountBlockedComponent } from "./shared/global/account-blocked/account-blocked.component";
import { ACCOUNT_BLOCKED_PATH } from "./shared/guards/billing-block.guard";
import { FlowSetupResolver } from "./shared/resolvers/flow-setup.resolver";
import { TRANSLOCO_SCOPE } from "@jsverse/transloco";
import { InnerSidenavHandlerService } from "./main/core/services/inner-sidenav-handler.service";
import { MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER } from "@angular/material/tooltip";

export const APP_ROUTES: Routes = [
    {
        path: "external-calendar/connect/:provider",
        loadComponent: () =>
            import("./main/external-calendar-access/external-calendar-access.component").then(
                (m) => m.ExternalCalendarAccessComponent,
            ),
        providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: "external-calendar-access",
                    alias: "externalCalendarAccess",
                },
                multi: true,
            },
        ],
    },
    { path: "", redirectTo: "/login", pathMatch: "full" },
    {
        path: "login",
        loadChildren: () =>
            import("./main/auth/auth.routes").then((m) => m.AUTH_ROUTES),
        providers: [
            { provide: TRANSLOCO_SCOPE, useValue: "auth", multi: true },
        ],
    },
    // Must stay before the core "" subtree and outside every BillingBlockGuard subtree.
    { path: ACCOUNT_BLOCKED_PATH, component: AccountBlockedComponent },
    {
        path: "",
        loadChildren: () =>
            import("./main/core/core.routes").then((m) => m.CORE_ROUTES),
        providers: [
            { provide: TRANSLOCO_SCOPE, useValue: "core", multi: true },
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: "system-fields",
                    alias: "system-fields",
                },
                multi: true,
            },
            {
                provide: TRANSLOCO_SCOPE,
                useValue: "server-errors",
                multi: true,
            },
        ],
    },
    {
        path: "business-setup",
        loadChildren: () =>
            import("./main/on-boarding/on-boarding.routes").then(
                (m) => m.ON_BOARDING_ROUTES,
            ),
        resolve: {
            mode: FlowSetupResolver,
        },
    },
    {
        path: "talkdesk",
        loadChildren: () =>
            import("./main/talkdesk/talkdesk.routes").then(
                (m) => m.TALKDESK_ROUTES,
            ),
        providers: [
            { provide: TRANSLOCO_SCOPE, useValue: "talkdesk", multi: true },
        ],
    },
    {
        path: "embedded-chat",
        loadChildren: () =>
            import("./main/embedded/embedded.routes").then(
                (m) => m.EMBEDDED_ROUTES,
            ),
        providers: [
            { provide: TRANSLOCO_SCOPE, useValue: "core", multi: true },
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: "system-fields",
                    alias: "system-fields",
                },
                multi: true,
            },
            {
                provide: TRANSLOCO_SCOPE,
                useValue: "server-errors",
                multi: true,
            },
            MAT_TOOLTIP_SCROLL_STRATEGY_FACTORY_PROVIDER,
        ],
    },
    {
        path: "oauth/authorize",
        loadComponent: () =>
            import("./main/oauth-authorize/oauth-authorize.component").then(
                (m) => m.OAuthAuthorizeComponent,
            ),
    },
    {
        path: "oauth2/authorize",
        loadComponent: () =>
            import("./main/oauth2-authorize/oauth2-authorize.component").then(
                (m) => m.OAuth2AuthorizeComponent,
            ),
        providers: [
            {
                provide: TRANSLOCO_SCOPE,
                useValue: {
                    scope: "oauth2-authorize",
                    alias: "oauth2-authorize",
                },
                multi: true,
            },
        ],
    },
    { path: "**", component: NotFoundComponent },
    { path: "404", component: NotFoundComponent },
];
